<template>
    <div>
        <div class="display-4 font-2xl my-3">Schedules</div>
        <schedule-server-table
          :filter_date="selected_date_obj"
          collection_status="Approved"
          :filterable="[]"
          :show_buttons="false"
          :route_override="true"
          @pushRoute="(id) => $router.push(`/instrument-runner/${id}`)"
          ref="schedules-table"
        />
    </div>
</template>
<script>
import ScheduleServerTable from "@/components/lab/schedule/ScheduleServerTable";
import moment from "moment";

export default {
    name: "InstrumentRunnerSchedulePicker",
    components: {
        ScheduleServerTable,
    },
    props: {
        selected_date: {
            required: true,
        },
    },
    computed: {
        selected_date_obj() {
            return moment(this.selected_date);
        }
    }
}
</script>